import { Component , OnInit } from '@angular/core';
import { SidebarService } from '../sidebar/sidebar.service';
import { Router, ActivatedRoute } from "@angular/router";
import { MasterService } from '../../../services/master.service';
import { RequestService } from '../../../services/request.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit{
    private intervalSubscription: Subscription;

    constructor(
        public sidebarservice: SidebarService,
        private router: Router,
        private route: ActivatedRoute,
        private masterService: MasterService,
        private request : RequestService,
    ) { }
    
    toggleSidebar() {
        this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
        
        if ($("#wrapper").hasClass("nav-collapsed")) {
            // unpin sidebar when hovered
            $("#wrapper").removeClass("nav-collapsed");
            $("#sidebar-wrapper").unbind( "hover");
        } else {
            $("#wrapper").addClass("nav-collapsed");
            $("#sidebar-wrapper").hover(
                function () {
                    $("#wrapper").addClass("sidebar-hovered");
                },
                function () {
                    $("#wrapper").removeClass("sidebar-hovered");
                }
            )
      
        }
    }
    
    getSideBarState() {
        return this.sidebarservice.getSidebarState();
    }

    hideSidebar() {
        this.sidebarservice.setSidebarState(true);
    }

    full_name;
    email;
    ngOnInit() {
        this.full_name = localStorage.getItem('full_name');
        this.email = localStorage.getItem('email');

        this.viewOrders();
        this.intervalSubscription = interval(10000).subscribe(() => {
            this.viewOrders();
          });

        /* Search Bar */
        $(document).ready(function () {
            $(".search-btn-mobile").on("click", function () {
                $(".search-bar").addClass("full-search-bar");
            });
            $(".search-arrow-back").on("click", function () {
                $(".search-bar").removeClass("full-search-bar");
            });
        });

    }

    playNotificationSound() {
        const audio = new Audio();
        audio.src = "assets/sound/notification.mp3";
        audio.load();
        audio.play().catch(err => {
            console.error("Playback failed", err);
        });
    }

    rowData;
    notificationCount=0;
    async viewOrders(){
        // alert("here");
        try {
        
        const orders = {
            action: 'view_pending_orders_today',
        };
        // console.log(orders);
        const data: any = await this.request.post('', orders);
        //alert(data);
        // console.log(data);
        for (let objKey of Object.keys(data)) {
            let dataObj = data[objKey];
            this.rowData = dataObj;
        }
        this.notificationCount = this.rowData.length;
        if(this.notificationCount>=0){
            // console.log("play");
            this.playNotificationSound();
        }
        console.log(this.notificationCount);
        } catch (error) {}
        // this.playNotificationSound();

    }

    Logout(){
        localStorage.clear();
        this.router.navigate(['/auth/signin']);
    }

    ngOnDestroy() {
        // Prevent memory leaks
        if (this.intervalSubscription) {
          this.intervalSubscription.unsubscribe();
        }
    }

    GotoViewOrder(){
        this.router.navigate(['/form/order-view']);
    }
}
